module.exports = __webpack_public_path__ + "static/media/blood-pact-logo.b3aa9317.png";